export default {
  pageTitle: {
    id: 'bo_seller-page_title',
    defaultMessage: 'Back Market',
  },
}
